import { createApi } from '@reduxjs/toolkit/query/react';
import   {appBaseQuery} from "../services/baseQuery"


export const mealItemApi = createApi({
  reducerPath: 'mealItemApi',
     baseQuery:appBaseQuery,

  tagTypes: ['MealItems'],
  endpoints: (builder) => ({
    // GET meal items 
    getMealItems: builder.query({
      query: ({ page = 1, limit = 10 }) =>
        `meal-items/?page=${page}&limit=${limit}`,
      providesTags: ['MealItems'],
    }),

    // POST (add new meal item)
    addMealItem: builder.mutation({
      query: (newItem) => ({
        url: 'meal-items/',
        method: 'POST',
        body: newItem,
      }),
      invalidatesTags: ['MealItems'],
    }),

    // PUT (update meal item)
    updateMealItem: builder.mutation({
      query: ({ uid, ...updatedData }) => ({
        url: `meal-items/${uid}/`,
        method: 'PUT',
        body: updatedData,
      }),
      invalidatesTags: ['MealItems'],
    }),

    // DELETE meal item
    deleteMealItem: builder.mutation({
      query: (uid) => ({
        url: `meal-items/${uid}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['MealItems'],
    }),
  }),
});

export const {
  useGetMealItemsQuery,
  useAddMealItemMutation,
  useUpdateMealItemMutation,
  useDeleteMealItemMutation,
} = mealItemApi;
